<template>
  <div class="resetRateContainer">
    <page-toolbar>
      <kendo-button icon="add" title="Add" v-show="editable" @click="addRowClick"> </kendo-button>
    </page-toolbar>
    <kendo-grid
      height="calc(100vh - 165px)"
      ref="resetRateGrid"
      :dataSource="dataSource"
      @edit="gridEdit"
      @remove="gridRemove"
      :editable="editable && 'inline'"
      :filterable="true"
      :sortable="true"
      :detailInit="createDetailGrid"
      @detailcollapse="gridCollapse"
      :columns="columns"
    >
    </kendo-grid>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import notification from '@/helpers/notification'
import {numericEditor} from '@/helpers/kendo-editors'
import PageToolbar from '@/components/PageToolbar'
import {getDataItem} from '@/helpers/kendo-helpers'
const $ = kendo.jQuery

export default {
  name: 'ResetRate',
  components: {
    PageToolbar,
  },
  mounted() {
    //this.$refs.operationGrid.$el.addEventListener('click', this.openScheduleDelivery, false)
    this.getData()
  },

  data() {
    return {
      defaultInitialDate: '',
      gridColumns: [],
      data: [],
    }
  },
  computed: {
    editable() {
      return this.role != 'Guest'
    },
    dataSource() {
      if (!this.data) return
      return new kendo.data.DataSource({
        //type: 'aspnetmvc-ajax',
        transport: {
          read: options => {
            options.success(this.data)
          },
          create: this.create,
          destroy: this.destroy,
        },
        schema: {
          model: {
            id: 'ResetRateId',
            fields: this.getDynamicFields(this.gridColumns, false),
          },
        },
      })
    },
    columns() {
      if (!this.gridColumns) {
        return
      }
      return this.getGridColumns(this.gridColumns, false)
    },
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
  },

  methods: {
    getData: function() {
      return new Promise(resolve => {
        axios
          .get('/api/heroux/resetRate/dataSource', {
            params: {
              dealId: this.dealId,
              t: new Date().getTime(),
            },
          })
          .then(req => {
            const response = req.data
            const {columns, data, defaultInitialDate} = response
            this.gridColumns = columns
            this.data = data
            this.defaultInitialDate = defaultInitialDate
            //kendo.ui.progress(container, false)
            resolve()
          })
          .catch(() => notification('Error getting dataSource', 'error'))
      })
    },
    create(options) {
      const grid = this.$refs.resetRateGrid.kendoWidget()
      const container = kendo.jQuery('.resetRateContainer')
      kendo.ui.progress(grid.element, false)
      kendo.ui.progress(container, true)
      const dataItem = this.getUpdateItems(options.data)

      axios
        .post('/api/heroux/resetRate/create', dataItem)
        .then(res => {
          if (res.status == 200) {
            const response = res.data
            this.defaultInitialDate = kendo.toString(response.defaultInitialDate, 'yyyy-MM-dd')
            options.success(response.data)
            this.getData().then(function() {
              kendo.ui.progress(container, false)
            })
          }
        })
        .catch(({response}) => {
          options.error('Error', response.status, response.statusText)
        })
    },
    destroy: async function(options) {
      const grid = this.$refs.resetRateGrid.kendoWidget()
      const container = kendo.jQuery('.resetRateContainer')
      kendo.ui.progress(grid.element, false)
      kendo.ui.progress(container, true)
      options.success(true)

      const destroyUrl = '/api/heroux/ResetRate/destroy'
      const date = kendo.toString(options.data['EvaluationDate'], 'yyyy-MM-dd')
      const {data} = await axios.delete(destroyUrl, {params: {evaluationDate: date}})
      this.defaultInitialDate = data.defaultInitialDate
      this.getData().then(function() {
        kendo.ui.progress(container, false)
      })
    },
    getDynamicFields(columns) {
      const dynamicFields = columns.reduce((acc, {field}) => {
        acc[field] = {
          field,
          editable: this.editable,
          required: true,
          type: 'number',
        }
        return acc
      }, {})

      return {
        ResetRateId: {type: 'number', defaultValue: 0, editable: false},
        EvaluationDate: {
          type: 'date',
          editable: false,
          defaultValue: this.defaultInitialDate,
        },
        ...dynamicFields,

        CanBeDeleted: {type: 'bool', defaultValue: true, editable: false},
      }
    },
    getUpdateItems(data) {
      const validColumns = this.gridColumns.filter(function(column) {
        return column.indexOf('EvaluationDate') < 0
      })

      const resetRateId = data.ResetRateId
      const evaluationDate = kendo.toString(data.EvaluationDate, 'yyyy-MM-dd')
      const canBeDeleted = data.CanBeDeleted
      const resetRateItems = []

      validColumns.forEach(function(column) {
        var newDataItem = {
          ResetRateCode: column,
          value: data[column],
        }
        resetRateItems.push(newDataItem)
      })
      var dataItem = {
        ResetRateId: resetRateId,
        EvaluationDate: evaluationDate,
        ResetRateItems: resetRateItems,
        CanBeDeleted: canBeDeleted,
      }
      return dataItem
    },
    getUpdateBatchItems(data, columns) {
      const validColumns = columns.filter(function(column) {
        return column.indexOf('EvaluationDate') < 0
      })

      const dataItems = []
      data.forEach(function(model) {
        const evaluationDate = kendo.toString(model['EvaluationDate'], 'yyyy-MM-dd')
        const resetRateId = model['ResetRateId']
        const resetRateItems = []

        validColumns.forEach(function(column) {
          const newDataItem = {
            ResetRateCode: column,
            value: model[column],
          }
          resetRateItems.push(newDataItem)
        })

        const dataItem = {
          ResetRateId: resetRateId,
          EvaluationDate: evaluationDate,
          ResetRateItems: resetRateItems,
        }
        dataItems.push(dataItem)
      })
      return dataItems
    },
    async createDetailGrid(expandElement) {
      const editable = this.editable
      const result = await axios.get('/api/heroux/resetRate/detailDataSource', {
        params: {
          evaluationDate: kendo.toString(expandElement.data.EvaluationDate, 'yyyy-MM-dd'),
        },
      })
      const response = result.data
      const columns = response.columns

      const detailDataSource = {
        transport: {
          read: function(options) {
            options.success(response.data)
          },
          update: async options => {
            const updateUrl = '/api/heroux/resetRate/updateDetail'
            const dataItems = this.getUpdateBatchItems(options.data.models, columns)
            const {data} = await axios.put(updateUrl, dataItems)
            options.success(data)
          },
        },
        batch: true,
        schema: {
          model: {
            id: 'ResetRateId',
            fields: this.getDynamicFields(columns, true),
          },
        },
      }

      const grid = $(
        "<div style='width: 96%;' id='detail_" +
          expandElement.data.ResetRateId +
          "' class='k-content' />",
      )
        .appendTo(expandElement.detailCell)
        .empty()
        .kendoGrid({
          navigatable: true,
          dataSource: detailDataSource,
          editable: this.editable && 'incell',
          hidden: false,
          resizable: false,
          reorderable: false,
          sortable: true,
          toolbar: this.editable ? ['save', 'cancel'] : [],
          columns: this.getGridColumns(columns, true),
        })
        .data('kendoGrid')

      if (!editable) {
        grid.element.find('.k-grid-toolbar').hide()
      }
    },
    gridCollapse() {
      this.getData()
    },
    getGridColumns(columns, isDetail) {
      const gridColumns = columns.map(column => ({
        ...column,
        width: 150,
        field: column,
        title: column,
        sortable: false,
        attributes: {style: 'text-align: right;'},
        template: e => {
          var value = e[column] || 0
          if (this.editable) {
            return "<span style='cursor:cell;'>" + kendo.toString(value, 'n5') + '</span>'
          } else {
            return '<span ' + kendo.toString(value, 'n5') + '</span>'
          }
        },
        editor: isDetail
          ? numericEditor({
              format: 'n5',
              spinners: false,
              decimals: 16,
              step: 0,
            })
          : '',
      }))

      if (!isDetail) {
        gridColumns.push({
          command: {
            name: 'exportDetail',
            iconClass: 'k-icon k-i-excel',
            click: (e => {
              const dataItem = getDataItem($(e.target).closest('tr'))
              const exportUrl =
                '/api/heroux/resetRate/exportDetailToExcel' +
                '?evaluationDate=' +
                kendo.toString(dataItem.EvaluationDate, 'yyyy-MM-dd')
              window.location.href = exportUrl + `&t=${this.tokenString}`
            }).bind(this),
          },
          title: 'Export Detail',
          width: 80,
          headerAttributes: {Class: 'ResetRateHeader'},
          attributes: {style: 'text-align: center;'},
        })

        gridColumns.push({
          field: 'CanBeDeleted',
          title: '&nbsp;',
          width: 60,
          filterable: false,
          sortable: false,
          attributes: {style: 'text-align: center;'},
          template:
            "# if(CanBeDeleted) { # <a class='k-button k-button-icontext k-grid-delete'><span class='k-icon k-i-delete'></span>Delete</a> # } #",
          hidden: !this.editable,
        })
      }

      return [
        {
          field: 'EvaluationDate',
          title: isDetail ? 'Evaluation Date' : 'Period Date',
          hidden: false,
          width: 120,
          headerAttributes: {Class: 'ResetRateHeader'},
          attributes: {Class: 'EvaluationDate'},
          template: function(dataItem) {
            if (isDetail) {
              return kendo.toString(dataItem.EvaluationDate, 'yyyy-MM-dd')
            }

            if (dataItem.ResetRateId == 0) return ''

            return kendo.toString(dataItem.EvaluationDate, 'MMM-yyyy')
          },
          //format: isDetail ? '{0:yyyy-MM-dd}' : '{0:MMM-yyyy}',
        },
        ...gridColumns,
        {},
      ]
    },
    addRowClick() {
      let grid = this.$refs.resetRateGrid.kendoWidget()
      grid.addRow()
      kendo.jQuery('.k-grid-edit-row').hide()
    },
    gridRemove(e) {
      const dataItem = getDataItem($(e.row))
      this.data = this.data.filter(d => d.ResetRateId != dataItem.ResetRateId)
    },
    gridEdit() {
      const grid = this.$refs.resetRateGrid.kendoWidget()
      grid.dataSource.sync()
    },
  },
}
</script>
